import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { ResponseData } from "./types/_public";
import { IFacility } from "./types/_facility";

const api = new APIClient();

const path = "/comments";

const winkCommentApi = {
  getComments(params: any): any {
    const url = `${path}`;
    return api.get(url, params);
  },

  getCommentDetail(
    id: string | number,
    params: any = {}
  ): Promise<AxiosResponse<ResponseData<IFacility>, any>> {
    const url = `${path}/${id}`;
    return api.get(url, params);
  },

  deleteComment(id: any) {
    return api.delete(`${path}/${id}`);
  },

  postComment(
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<IFacility>, any>> {
    const url = `${path}`;
    return api.post(url, dataForm);
  },

  putComment(
    id: string | number,
    dataForm: any
  ): Promise<AxiosResponse<ResponseData<IFacility>, any>> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm);
  },
};

export default winkCommentApi;
